import React from 'react';
import { Container } from '@mui/material';

import { ConstructionCompanyRegistrationFormProps } from '../../types/company.types';
import { useConstructionRegistrationForm } from '../../hooks/construction-company/use-construction-registration-form';
import { RegisterForm } from '../register-form';

import { ConstructionInfoSection } from '@/features/companies/components/construction-company/construction-info-section';
import HeaderRegister from '@/features/apps/components/header-register';

export const ConstructionRegistrationForm: React.FC<ConstructionCompanyRegistrationFormProps> = ({
  onSubmit,
  onCancel,
}) => {
  const {
    formData,
    validationState,
    updateField,
    addRepresentative,
    removeRepresentative,
    updateRepresentative,
    handleSubmit,
    getFieldError,
    isFieldValid,
    getSalesPersonOptions,
    canAddRepresentative,
    isSubmitDisabled,
    departments,
    departmentsLoading,
    staffsLoading,
    handleDepartmentChange,
  } = useConstructionRegistrationForm(onSubmit);
  const handleFormSubmit = async () => {
    await handleSubmit();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Container maxWidth='lg' sx={{ py: 4 }}>
      {/* Header */}
      <HeaderRegister title='建設会社登録フォーム' description='建設会社情報を入力してください' />

      <RegisterForm
        validationState={validationState}
        formData={formData}
        addRepresentative={addRepresentative}
        removeRepresentative={removeRepresentative}
        updateRepresentative={updateRepresentative}
        getSalesPersonOptions={getSalesPersonOptions}
        getFieldError={getFieldError}
        isFieldValid={isFieldValid}
        canAddRepresentative={canAddRepresentative}
        departments={departments}
        departmentsLoading={departmentsLoading}
        staffsLoading={staffsLoading}
        handleDepartmentChange={(departmentId) => {
          void handleDepartmentChange(departmentId);
        }}
        handleCancel={handleCancel}
        handleFormSubmit={() => {
          void handleFormSubmit();
        }}
        isSubmitDisabled={isSubmitDisabled}
        hasNavigationPanel={false}
      >
        {/* Construction Company Information Section */}
        <ConstructionInfoSection
          formData={formData}
          onUpdateField={updateField}
          getFieldError={getFieldError}
          isFieldValid={isFieldValid}
        />
      </RegisterForm>
    </Container>
  );
};
